import { ICarbonDetailFormValues } from '@Router/EsgGreenhouse/Containers/EsgGreenhouseFormProvider/types';
import { OrganizationType } from 'src/Enum/EsgGreenhouse';
import {
  setBoolean,
  setDateMonthToFirst,
  setNumber,
} from '../../NetZero/ModalNetZero/utils';

export const createNewCarbonDetails = (data: ICarbonDetailFormValues) => {
  return {
    scopeId: data.scopeId,
    baseYear: {
      year: setDateMonthToFirst(data.baseYear?.year),
      gasEmissionQuantity: setNumber(data.baseYear?.gasEmissionQuantity),
    },
    target: {
      year: setDateMonthToFirst(data.target?.year),
      gasEmissionPercent: setNumber(data.target?.gasEmissionPercent),
      gasEmissionQuantity: setNumber(data.target?.gasEmissionQuantity),
    },
    isGuarantee: setBoolean(data.isGuarantee),
    organizationId:
      data.organizationId === '' ? undefined : data.organizationId,
    organizationTh: data?.organizationTh,
    organizationEn: data?.organizationEn,
  };
};

export const mapCarbonFormValues = (
  data: ICarbonDetailFormValues
): ICarbonDetailFormValues => {
  return {
    ...data,
    baseYear: {
      ...data.baseYear,
      gasEmissionQuantity: data.baseYear?.gasEmissionQuantity
        ? String(data.baseYear.gasEmissionQuantity)
        : undefined,
    },
    target: {
      ...data.target,
      gasEmissionPercent: data.target.gasEmissionPercent
        ? String(data.target.gasEmissionPercent)
        : undefined,
      gasEmissionQuantity: data.target.gasEmissionQuantity
        ? String(data.target.gasEmissionQuantity)
        : undefined,
    },
    organizationId: data.organizationId ?? '',
    organizationTh: data.organizationTh ?? '',
    organizationEn: data.organizationEn ?? '',
  };
};

export const checkCarbonVerificationComplete = (
  data: ICarbonDetailFormValues,
  isCompleteTh: boolean,
  isCompleteEn: boolean
): boolean => {
  if (isCompleteTh || isCompleteEn) {
    return data.organizationId === OrganizationType.OTHER_GHG_MGNT_ORGANIZATION;
  }
  return true;
};
